import React from "react";
import "../App.css";

export const Project = () => {
  document.title="Lishal Bhari | Projects"
  return (
    <div className="lis-container_project">
      {/* Project 1 */}
      <div className="lis-project_democard">
        <div className="lis-democard_img">
          <img src="./Images/covid.png" alt="Lishal Bhari" />
          <div className="lis-democard_content">
            <span>No. 1</span>
            <span>Live Covid Tracker</span>
            <span>
              <a
                href="https://liveupdate-covid19.netlify.app/"
                target="__blank"
              >
                <i className="fa fa-external-link"></i>
              </a>
            </span>
          </div>
        </div>
      </div>
      {/* Project 2 */}
      <div className="lis-project_democard">
        <div className="lis-democard_img">
          <img
            src="./Images/Counter.png"
            // src="/"
            alt="Lishal Bhari"
          />
          <div className="lis-democard_content">
            <span>No. 2</span>
            <span>Simple Counter</span>
            <span>
              <a
                href="https://simplecounter-lishal.netlify.app/"
                target="__blank"
              >
                <i className="fa fa-external-link"></i>
              </a>
            </span>
          </div>
        </div>
      </div>
    {/* Project 3 */}
      <div className="lis-project_democard">
        <div className="lis-democard_img">
          <img src="./Images/imagenf.jpg" alt="Lishal Bhari" />
          <div className="lis-democard_content">
            <span>No. 3</span>
            <span>Cinema Management</span>
            <span>
              <a
                href="https://github.com/lishal/CinemaManagement"
                target="__blank"
              >
                <i className="fa fa-external-link"></i>
              </a>
            </span>
          </div>
        </div>
      </div>
      {/* Project 4 */}
      <div className="lis-project_democard">
        <div className="lis-democard_img">
          <img src="./Images/imagenf.jpg" alt="Lishal Bhari" />
          <div className="lis-democard_content">
            <span>No. 4</span>
            <span>Restaurant Management</span>
            <span>
              <a
                href="https://github.com/lishal/Resturant-Booking"
                target="__blank"
              >
                <i className="fa fa-external-link"></i>
              </a>
            </span>
          </div>
        </div>
      </div>

      {/* Project 5 */}
      <div className="lis-project_democard">
        <div className="lis-democard_img">
          <img src="./Images/tictactoe.png" alt="Lishal Bhari" />
          <div className="lis-democard_content">
            <span>No. 5</span>
            <span>TTic-Tac-Toe</span>
            <span>
              <a
                href="https://tic-tac-toe-coral-gamma.vercel.app/"
                target="__blank"
              >
                <i className="fa fa-external-link"></i>
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
